import styled from 'styled-components'

export const ModalWindow = styled.div`
  position: fixed;
  background-color: rgba(0, 0, 0, 0.75);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999999;
  visibility: hidden;
  opacity: 0;
  /* pointer-events: none; */
  transition: all 0.3s;

  &.active {
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
  }

  .card-background {
    width: 100%;
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -1;
    background: transparent;
    border: 0;
  }

  div.card-modal {
    width: 90%;
    max-width: 650px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 0;
    background: #ffffff;
    border-radius: 6px;
  }

  .modal-close {
    color: #b34242;
    position: absolute;
    right: 0;
    text-align: center;
    background: transparent;
    border: 1px solid #fdc6c6;
    top: -42px;
    -webkit-text-decoration: none;
    padding: 7px 15px;
    -webkit-text-decoration: none;
    text-decoration: none;
    cursor: pointer;
    border-radius: 4px;
    background: #ffebeb;
  }

  .content-modal {
    max-height: calc(100vh - 230px);
    overflow-y: scroll;
    padding: 20px;
    padding-top: 0;

    h5 {
      font-size: 18px;
      font-weight: bold;
      color: #000;
      margin-bottom: 10px;
    }

    p {
      margin-bottom: 15px;
    }
  }
  
  header {
    font-weight: bold;
  }

  h4 {
    font-size: 24px !important;
    color: #000;
    margin: 20px 20px 15px 20px;
  }
`

export const Customers = styled.div`
  .header {
    padding: 100px 0;

    > h1, > h2, h2 > strong {
      text-align: center;
      font-size: 32px;
      line-height: 1.1;

      strong {
        font-weight: 900;
        font-size: 32px;
        color: var(--color-primary);
      }
    }

    > h1 {
      color: #4F4F4F;
    } 

    > h2 {
      color: "#707070";
      
      strong {
        color: #000;
      }
    }
  }
`

export const Case = styled.div`
  margin-bottom: 120px;

  h3 {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 5px;
    color: #000;
  }

  .product {
    margin-bottom: 35px;
    display: flex;
    flex-direction: column;
    align-items: center;

    &__icon {
      width: 60px;
      height: 60px;
      margin-bottom: 15px;
    }

    &__name {
      font-weight: 900;
      font-size: 24px;
      color: #000;
      text-align: center;
    }
  }

  .content-product {
    &__title {
      margin-bottom: 20px;
      font-size: 18px;
      font-weight: 700;
    }

    &__text {
      /* margin-bottom: 30px; */

      strong {
        font-weight: bold;
      }

      ul {
        margin-left: 20px;
        margin-bottom: 15px;

        &.highlight {
          background: #f9f9f9;
          border: 1px solid #e2e2e2;
          padding: 20px 20px 20px 40px;
          margin-left: 0;
          border-radius: 6px;
        }
      }

      p {
        margin-bottom: 15px;
      }
    }

    &__features {
      display: flex;
      margin-bottom: 30px;
      margin-left: -10px;
      margin-right: -10px;

      &-column {
        flex: 1;
        display: flex;
        margin: 0 10px;
      }

      &-icon {
        width: 40px;
        margin-right: 15px;
        
        > div {
          background-color: #dcf2ff;
          width: 40px;
          height: 40px;
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        svg {
          fill: var(--color-primary);
          width: 14px;
          height: 14px;
        }
      }

      &-text {
        flex: 1;
      }


    }

    &__links {
      display: flex;
      flex-direction: column;
      align-items: self-start;

      a {
        text-decoration: none;
      }

      button {
        background: transparent;
        border: 0;
        outline: none;
        cursor: pointer;
        font-weight: 700;
        color: var(--color-primary);
        
        display: flex;
        align-items: center;
        margin-top: 3px;

        svg {
          fill: var(--color-primary);
          width: 14px;
          height: auto;
          margin-top: 5px;
          margin-left: 6px;
          transition: all .3s;
        }

        &:hover {
          svg {
            margin-left: 10px;
          }
        }
      }
    }
  }

  .grid-case {
    display: flex;
    margin-bottom: 30px;

    > div {
      flex: 1;
      margin: 0 10px;
      display: flex;
      align-items: center;
    }

    .card {
      width: calc(100% + 40px);
      margin-left: -50px;
      border-radius: 6px;
      padding: 40px;
      overflow: hidden;
      -webkit-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.14);
      -moz-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.14);
      box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.14);

      &--james {
        background-color: #984ded;
      }

      &--rana {
        background-color: #1e6fad;
      }

      &--skillcore, &--logicaldelivery {
        background-color: #0e0e0e
      }

      &--quadritech {
        background-color: #0089bd;
      }

      &__image {
        height: 205px;
        margin-left: -40px;
        margin-top: -40px;
        margin-right: -40px;
        background-size: cover;
        background-position: center;
        margin-bottom: 40px;
      }

      &__text {
        color: #fff;
        font-weight: 300;
        font-size: 20px;
        line-height: 1.3;
        margin-top: 20px;
        font-style: italic;
      }

      button {
        background: transparent;
        border: 1px solid #fff;
        color: #fff;
        height: 35px;
        padding: 0 15px;
        border-radius: 6px;
        margin-top: 20px;
        cursor: pointer;
      }

      &__person {
        margin-top: 20px;

        &-name {
          color: #fff;
          font-size: 18px;
          font-weight: bold;
        }

        &-position {
          color: #fff;
          font-size: 14px;
        }
      }
    }
  }

  &.left {
    .grid-case {
      > div:nth-child(1) {
        order: 1;
      }

      > div:nth-child(2) {
        order: 0;
      }

      .card {
        margin-right: -50px;
        margin-left: 0;
      }
    }
  }

  @media screen and (max-width: 1000px) {
    margin-bottom: 50px;

    &.left {
      .grid-case {
        > div:nth-child(1) {
          order: 0;
        }

        > div:nth-child(2) {
          order: 1;
        }
      }
    }

    .product {
      margin-bottom: 15px;
      display: flex;
      flex-direction: column;
      align-items: center;

      &__icon {
        width: 60px;
        height: 60px;
        margin-bottom: 15px;
      }

      &__name {
        font-weight: 900;
        font-size: 18px;
        color: #000;
        text-align: center;
      }
    }

    .content-product {
      &__features {
        flex-direction: column;

        &-column {
          margin-bottom: 15px;
        }
      }

      &__links {
        button {
          text-align: left;
        }
      }
    }
    
    .grid-case {
      flex-direction: column;
      // margin-bottom: 0;

      > div {
        margin: 0;
      }

      .card {
        width: calc(100%);
        margin-left: 0px;
        padding: 15px;
        margin-bottom: 20px;

        &__image {
          height: 125px;
          margin-bottom: 15px;
        }

        &__text {
          font-weight: 300;
          font-size: 16px;
          line-height: 1.3;
          margin-top: 15px;
        }
      }

      
    }
  }
`